import axios from 'axios';
import { API_BASE_HEALTH_CENTER_URL, API_HEALTH_CENTERS, API_HEALTH_CENTER_BY_ID } from '../../../helpers/urlHelper';

export const getAllHealthCenters = async () => {
    const fullUrl = `${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTERS}`;
    console.log("🌐 Llamando a:", fullUrl); // <-- aquí lo ves en consola
    const response = await axios.get(`${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTERS}`);
    return response.data;
};

export const getHealthCenterById = async (id) => {
    const response = await axios.get(`${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTER_BY_ID}/${id}`);
    return response.data;
};

export const createHealthCenter = async (data) => {
    const response = await axios.post(`${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTERS}`, data);
    return response.data;
};

export const updateHealthCenter = async (id, data) => {
    const response = await axios.put(`${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTER_BY_ID}/${id}`, data);
    return response.data;
};

export const deleteHealthCenter = async (id) => {
    const response = await axios.delete(`${API_BASE_HEALTH_CENTER_URL}${API_HEALTH_CENTER_BY_ID}/${id}`);
    return response.data;
};